var global         = require('./_global')
  , core           = require('./_core')
  , LIBRARY        = require('./_library')
  , wksExt         = require('./_wks-ext')
  , defineProperty = require('./_object-dp').f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/core-js/modules/_wks-define.js
// module id = ../../../../core-js/modules/_wks-define.js
// module chunks = 3